import script from "./VATReturnsTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./VATReturnsTabs.vue?vue&type=script&setup=true&lang=ts"

import "./VATReturnsTabs.vue?vue&type=style&index=0&id=7570ab44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7570ab44"]])

export default __exports__